import queryString from 'query-string';
import { getPlaylist, setARPlaylist } from './common/playlist/playlistActions';
import { getStudentResults } from './common/api/resultStudentActions';
import {
    startRetriableGet, retriableGetComplete,
    retriableGetFailed,
} from './common/api/apiCallActions';
import { APP_DATA_FETCH_RETRY } from './common/api/apiRetryGetConstants';
import { ALL_PERIODS } from './constants/result';
import selectors from './rootSelectors';
import { LANTERN_ERROR_CODES } from './constants/error';
import {setSecureBrowserError} from "./common/secureBrowser/secureBrowserActions";

// eslint-disable-next-line import/prefer-default-export
export const fetchApplicationData = () => (dispatch, getStore) => {
    const store = getStore();
    const { period } = queryString.parse(window.location.search);

    /* eslint-disable no-else-return */
    if(selectors.getExternalURLSourceStatus(store) && ALL_PERIODS.includes(period)) {
        return dispatch(setARPlaylist(period))
            .then(() => dispatch(getStudentResults()));
    } else {
        // TODO investigate why nobody waits for this promise and how this situation affects the flow
        dispatch(startRetriableGet(APP_DATA_FETCH_RETRY));
        return dispatch(getPlaylist())
            .then(() => {
                dispatch(retriableGetComplete(APP_DATA_FETCH_RETRY));
            }, () => {
                dispatch(retriableGetFailed(APP_DATA_FETCH_RETRY));
            });
    }
};

export const showErrorInChromeOSWithoutKiosk = () => (dispatch) => {
    dispatch(setSecureBrowserError(LANTERN_ERROR_CODES.CHROME_OS_WITHOUT_KIOSK));
};
